<template>
  <div style="background:#fff;">
    <Banner image="guitarra-2" />
    <v-container>
      <v-row>
        <section class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
          <div class="title-content">
            <h2 class="display-1">Blogs</h2>
          </div>
            <p class="subtitle-1 grey--text text--darken-1">Poemas, novelas e historias aquí podrás encontrar un mundo contado con mi palabras.</p>
          <v-row>
            <v-col cols="auto" xs="12" sm="6" md="4" lg="4" class="article" data-aos="zoom-in" data-aos-delay="500" v-for="item in displayedArticles" :key="item._id">
              <div class="article-img">
                <router-link :to="{name: 'blog', params: { id: item._id }}" target="_blank">
                  <img :src="item.imageURL" alt="">
                </router-link>
              </div>
              <span class="article-category font-weight-light body-2">{{item.category.name}}</span>
              <h3 class="article-title"><router-link :to="{name: 'blog', params: { id: item._id }}" class="grey--text text--darken-3" target="_blank">{{item.title}}</router-link></h3>
              <span class="article-date body-2 mb-3 grey--text text--darken-1">{{item.date | momentDate}}</span>
              <p class="article-author">{{item.author}}</p>
            </v-col>
          </v-row>
          <v-row>
              <v-col>
                <v-pagination
                  v-model="page"
                  :length="Math.ceil(this.articles.length / this.perPage)"
                  circle color="#2F1640"
                  total-visible="9"
                ></v-pagination>
              </v-col>
          </v-row>
        </section>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <section-lateral></section-lateral>
        </div>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Banner from '@/components/BannerBlog';
import SectionLateral from '@/components/SectionLateral';
const moment = require('moment');
  export default {
    name:'blogs',
    components:{Banner,SectionLateral},
    data(){
      return{
        articles:[],
        page:1,
        perPage:9,
        pages:[]
      }
    },
    created(){
      this.getArticles()
    },
    watch:{
      articles(){
        this.setArticles()
      }
    },
    methods:{
      async getArticles(){
        const res = await this.axios.get(`${this.$store.state.baseURL}/api/blogs/show`)
        this.articles = res.data
      },
      paginate(articles){
        let page = this.page
        let perPage= this.perPage
        let from = (page * perPage) - perPage
        let to = (page * perPage)
        return articles.slice(from, to)
      },
      setArticles(){
        let numberOfPages = Math.ceil(this.articles.length / this.perPage)
        for (let i = 1; i <= numberOfPages; i++) {
          this.pages.push(i)
        }
      }
    },
    computed:{
      displayedArticles(){
        let order = this.articles.sort((a, b) => new Date(a.date) - new Date(b.date)).reverse()
        return this.paginate(order)
      }
    },
    filters:{
      momentDate: function (value) {
        moment.locale('es');
        return moment(value).format("MMM Do YY")
      }
    }
  }
</script>

<style lang="scss" scoped>
.title-content{
  border-bottom: 1px solid #E0E0E0;
}
.article{
   @media screen and (max-width:600px){ 
    width: 100%;
  }
  &-img{
    position: relative;
    width: 100%;
    height: 0;
    overflow: hidden;
    padding-bottom: 56.25%;
    & a{
      text-decoration: none;
      & img {
        border-radius: 10px;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        object-fit: cover;
      }
    }
  }
  &-category{
    color:  #8C634A;
    text-transform: uppercase;
  }
  &-title{
    font-size: 17px;
    & a {
      text-decoration: none;
      &:hover{
        text-decoration: underline;
      }
    }

  }
  &-author{
    font-size: 16px;
    font-weight: 500;
    letter-spacing: .0125em!important;
    line-height: 2rem;
    font-family: Roboto,sans-serif!important;
  }
}
</style>